import type { Weight } from '@iheartjane/types';

import type { AlgoliaProduct } from '@jane/search/data-access';
import { getLabResults } from '@jane/shared-ecomm/util';
import type { MenuProduct } from '@jane/shared/types';

/** @returns the price id matching the product's percent_thc property */
export const getPriceIdForPercentThc = (
  product: MenuProduct | AlgoliaProduct,
  availableWeights: Weight[]
) =>
  availableWeights
    .map(({ id }) => id)
    .find((priceId) => {
      const { percentThc } = getLabResults(product, priceId);
      return percentThc === product.percent_thc;
    }) ?? 'each';
